module.exports = __webpack_public_path__ + "img/9788949123110.0a49d85a.jpg";